import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import FunctionsIcon from '@mui/icons-material/Functions';
import { IconButton, Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';

interface ReviewStepHeaderProps {
  title: string;
  positionLabel: string;
  previousLabel: string;
  nextLabel: string;
  canGoBack: boolean;
  canGoNext: boolean;
  onBack: () => void;
  onNext: () => void;
  /** Leading icon; defaults to the variable (Σ) icon. */
  icon?: ReactNode;
  /** Adds a close button at the end of the row when set. */
  onClose?: () => void;
  closeLabel?: string;
}

export const ReviewStepHeader = ({
  title,
  positionLabel,
  previousLabel,
  nextLabel,
  canGoBack,
  canGoNext,
  onBack,
  onNext,
  icon,
  onClose,
  closeLabel,
}: ReviewStepHeaderProps) => (
  <Stack direction="row" alignItems="center" justifyContent="space-between">
    <Stack direction="row" alignItems="center" spacing={1}>
      {icon ?? (
        <FunctionsIcon sx={{ fontSize: 16, color: 'primary.main', flexShrink: 0 }} aria-hidden />
      )}
      <Typography variant="body2" color="text.secondary">
        {title}
      </Typography>
    </Stack>
    <Stack direction="row" alignItems="center" spacing={1}>
      <IconButton
        size="small"
        onClick={onBack}
        disabled={!canGoBack}
        aria-label={previousLabel}
        data-testid="review-prev"
      >
        <ChevronLeftRoundedIcon fontSize="small" />
      </IconButton>
      <Typography variant="body2" color="text.secondary" data-testid="review-position">
        {positionLabel}
      </Typography>
      <IconButton
        size="small"
        onClick={onNext}
        disabled={!canGoNext}
        aria-label={nextLabel}
        data-testid="review-next"
      >
        <ChevronRightRoundedIcon fontSize="small" />
      </IconButton>
    </Stack>
    {onClose && (
      <IconButton
        size="small"
        onClick={onClose}
        aria-label={closeLabel}
        data-testid="review-close"
        sx={{ marginLeft: 1 }}
      >
        <CloseRoundedIcon fontSize="small" />
      </IconButton>
    )}
  </Stack>
);
